import(/* webpackMode: "eager" */ "/home/runner/work/sk-aqua/sk-aqua/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/sk-aqua/sk-aqua/components/CartModal.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/home/runner/work/sk-aqua/sk-aqua/context/CartContext.jsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/sk-aqua/sk-aqua/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/sk-aqua/sk-aqua/node_modules/next/font/google/target.css?{\"path\":\"app/layout.jsx\",\"import\":\"Cormorant_Garamond\",\"arguments\":[{\"subsets\":[\"cyrillic\"],\"weight\":[\"400\"],\"style\":[\"normal\",\"italic\"],\"variable\":\"--font-display\",\"display\":\"swap\",\"preload\":false}],\"variableName\":\"cormorant\"}");
